import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

const InventoryStock = ({ stock, handleChangeStock, stockError }) => {
  const { t } = useTranslation();

  return (
    <TextField
      size="small"
      name="stock"
      autoFocus
      fullWidth
      label={t('Stock Quantity')}
      type="text"
      variant="outlined"
      value={stock}
      onChange={handleChangeStock}
      error={!!stockError}
      helperText={stockError || t('Enter a whole number')}
      inputProps={{
        inputMode: 'numeric',
        pattern: '[0-9]*',
      }}
      InputLabelProps={{ shrink: true }}
      sx={{
        minHeight: '64px',
      }}
    />
  );
};

export default InventoryStock;
